import React from 'react'

import Button from "../Util/Button"

import "./AboutUsZh.css"


const AboutUsZh = () => {

    return ( 
        <div className='aboutZh'>

            <section className='start'>

                <div className='heading'>

                    <div className='logo'>
                        <img src="./images/logo3.svg" alt="" decoding='async' />
                        <p>SINIS</p>
                    </div>

                    <h1> 
                        搭建 <br/> 
                        <span> 中德经济合作 </span> <br/>
                        的桥梁  <br/>
                    </h1>

                </div>

                <div className='shape right'>
                    <img className='img' src='./images/about-1.webp' alt='' loading='eager' decoding='async' />
                    <span className='overlay'/>
                </div>
                
            </section>

            <section className='about-intro'>
                <h2>
                    <img src="./images/logo3.svg" alt="" decoding='async' />
                    关于 SINIS
                </h2>

                <p>
                    醒狮中德商联（SINIS GmbH） 成立于2002年，总部位于德国慕尼黑南部，致力于推动中欧经贸往来，促进国际投资合作。我们的使命是将欧洲市场需求引入中国，同时助力中国企业拓展欧洲市场，搭建高效、专业的双向经贸合作平台。凭借在中国和欧洲深厚的经济网络及广泛的合作伙伴资源，我们为中国企业和个人提供全方位、一站式的专业服务，涵盖投资咨询、签证与移民、公司设立、市场拓展等多个领域。
                </p>

                <span className='shape left'/>
            </section>

            <section className='about-info'>

                <img src='./images/about-2.webp' alt='' loading='lazy' decoding='async' />

                <span className='shape right'>
                    <p>
                        <span>1. 德国签证与移民服务 </span><br/>
                        签证申请（包括工作签证、留学签证、投资签证等）<br/>
                        移民咨询（长期居留、永居及入籍规划）<br/>
                        居留许可及落地支持（法律咨询、税务登记、社保办理等）
                    </p>

                    <p>
                        <span>2. 德国商务与投资服务 </span><br/>
                        公司设立及并购支持（注册德国公司或子公司，企业并购、财务合规） <br/>
                        商务基础设施（高性价比办公场地、企业落地支持） <br/>
                        投资咨询（市场分析、法律法规解读、投资可行性评估） <br/>
                        国际招标及商务代理（帮助企业对接欧洲市场资源） <br/>
                        市场拓展（商务对接、行业合作、品牌推广） <br/>
                        国际博览会及展会支持（协助企业参展、商务洽谈） <br/>
                        欧盟商标注册（EU商标）
                    </p>

                    <p>
                        <span>3. 中欧国际贸易 </span><br/>
                        促进中欧双边贸易往来（进出口贸易、采购代理）<br/>
                        跨境文化与商务交流（旅游考察、商贸对接）<br/>
                    </p>
                </span>

            </section>


            <section className='about-end'>
                <div className='logo'>
                    <img src="./images/logo3.svg" alt="" decoding='async' />
                    <p>SINIS</p>
                </div>

                <p>
                    我们与中德两国的高校、职业院校、企业联盟及政府机构保持紧密合作，依托广泛的资源网络和专业化的服务体系，为赴德深造的学员及希望进入德国市场的企业提供高效、合规、定制化的解决方案。醒狮中德商联致力于为客户打造进入德国及欧洲市场的最优路径，成为中德经贸合作的桥梁和纽带，助力企业在欧洲市场取得成功。
                </p>

                <Button to="/contact" filled>联系我们</Button>

            </section>    

                

        </div>
    );
}
 
export default AboutUsZh;